import React from "react";
import styles from "./Calendar.module.css";

const weekdays = ["D", "S", "T", "Q", "Q", "S", "S"];
const daysInMonth = 30;

const specialDates = {};

export default function CalendarAluno() {
  return (
    <div className={styles.container}>
      <h3 className={styles.title}>Calendário</h3>
      <div className={styles.weekdays}>
        {weekdays.map((day, idx) => (
          <span key={idx} className={styles.weekday}>
            {day}
          </span>
        ))}
      </div>
      <div className={styles.days}>
        {Array.from({ length: 30 }, (_, i) => {
          const day = i + 1;
          const tag = specialDates[day];

          return (
            <div
              key={day}
              className={`${styles.day} ${tag ? styles[tag] : ""}`}
            >
              {day}
            </div>
          );
        })}
      </div>

      <div className={styles.legend}>
        <div className={styles.legendItem}>
          <span className={`${styles.dot} ${styles.greenFilled}`}></span>
          Avaliações
        </div>
        <div className={styles.legendItem}>
          <span className={`${styles.dot} ${styles.green}`}></span>
          Atividades
        </div>
        <div className={styles.legendItem}>
          <span className={`${styles.dot} ${styles.blue}`}></span>
          Fóruns
        </div>
      </div>
    </div>
  );
}
